export enum FORM_STEP {
  TIMESLOT = 'TIMESLOT',
  CONTACT_INFO = 'CONTACT_INFO',
  RESERVATION_SUMMARY = 'RESERVATION_SUMMARY',
  RESERVATION_CONFIRMATION = 'RESERVATION_CONFIRMATION',
}
